import { render } from "./History.vue?vue&type=template&id=c8ea34da&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=c8ea34da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c8ea34da"

export default script